import { useMemo, useState } from 'react';
import { useFormContext } from 'framework/form';
import { isEmpty } from 'lodash';
import { Box } from '@mui/material';
import ComplianceDocumentFormActionButtons from '../shared/buttons/actions/ComplianceDocumentFormActionButtons';
import ComplianceDocumentFormFields from '../shared/form/ComplianceDocumentFormFields';
import ComplianceDocumentFormPreview from '../shared/ComplianceDocumentFormPreview';
import { ComplianceDocumentFormType } from 'domain/shared/compliance';

const ComplianceDocumentForm = ({
  isEditForm = false,
  closeModal,
}: {
  isEditForm?: boolean;
  closeModal?: () => void;
}) => {
  const { data: formData, validateForm } = useFormContext();
  const [publishView, setPublishView] = useState(false);

  const { paths } = formData || {};
  const documentPath = useMemo(() => (paths?.length ? paths[0] : ''), [paths]);

  const togglePublishView = () => {
    const errors = validateForm?.();
    if (!errors || isEmpty(errors)) setPublishView(prev => !prev);
  };

  return (
    <>
      <Box>
        <Box display={publishView ? 'none' : 'block'}>
          <ComplianceDocumentFormFields isEditForm={isEditForm} />
        </Box>

        {publishView && (
          <ComplianceDocumentFormPreview
            formData={formData as ComplianceDocumentFormType}
            documentPath={documentPath}
          />
        )}
      </Box>

      <ComplianceDocumentFormActionButtons
        isEditForm={isEditForm}
        publishView={publishView}
        onTogglePublishView={togglePublishView}
        onCancel={closeModal!}
        onCancelPreview={() => setPublishView(false)}
      />
    </>
  );
};
export default ComplianceDocumentForm;
